<template>
  <v-data-table
    v-if="hasUserRoles"
    data-private
    disable-sort
    disable-pagination
    hide-default-footer
    data-testid="addPeopleBulk-table-successUsers"
    :headers="columns"
    :items="userList"
  >
    <template v-slot:item.name="{ item }">
      <div class="d-flex align-center">
        <UserAvatar :account="item" size="28px" fontSize="10px" />
        <p class="ma-0 pa-0 ml-2">{{ item.displayname }}</p>
      </div>
    </template>
    <template v-slot:item.email="{ item }">
      <p>{{ item.email }}</p>
    </template>
    <template v-slot:item.roles="{ item }">
      <v-tooltip bottom max-width="200" :disabled="disableTooltip(item.email)">
        <template v-slot:activator="{ on }">
          <p v-on="on">{{ mainRole(item.email) }}</p>
        </template>
        <ul>
          <li v-for="role in defineTooltipRoles(item.email)" :key="role">
            {{ role }}
          </li>
        </ul>
      </v-tooltip>
    </template>
  </v-data-table>
</template>

<script>
import _ from 'lodash'

import UserAvatar from '@/components/UserAvatar.vue'

export default {
  name: 'SuccessfullUsers',

  components: {
    UserAvatar,
  },

  props: {
    userList: {
      type: Array,
      default() {
        return []
      },
    },
    showRoleColumn: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      headers: [
        {
          text: this.$t('common.name'),
          value: 'name',
          show: true,
        },
        {
          text: this.$t('common.email_one'),
          value: 'email',
          show: true,
        },
        {
          text: this.$t('common.roles.role_plural_header'),
          value: 'roles',
          show: this.showRoleColumn,
        },
      ],
      userRoles: [],
    }
  },

  async mounted() {
    this.defineColumnRoles()
  },

  computed: {
    hasUserRoles() {
      return !_.isEmpty(this.userRoles)
    },

    columns() {
      return this.headers.filter(h => h.show)
    },
  },

  methods: {
    rolesList(account) {
      const rolesList = []

      if (account.isRoutineManager) {
        rolesList.push(this.$t('common.roles.routine_manager'))
      }

      if (account.isCoach) {
        rolesList.push(this.$t('common.roles.coach_one'))
      }

      if (account.isOrganizationAdmin) {
        rolesList.push(this.$t('common.roles.organization_admin'))
      }

      if (account.isSiteAdmin) {
        rolesList.push(this.$t('common.roles.site_admin'))
      }

      if (account.canDoFinancialValidation) {
        rolesList.push(this.$t('common.roles.impact_validator'))
      }

      return rolesList
    },

    defineColumnRoles() {
      this.userRoles = this.userList.map(user => {
        return {
          email: user.email,
          roles: this.rolesList(user),
        }
      })
    },

    mainRole(email) {
      const { roles } = this.userRoles.find(user => user.email === email)
      if (roles.length === 0) return

      if (roles.length === 1) {
        return roles[0]
      } else {
        return this.$t('common.roles.multiple_roles', {
          roleName: roles[0],
          numberOfRoles: roles.length - 1,
        })
      }
    },

    defineTooltipRoles(email) {
      const { roles } = this.userRoles.find(user => user.email === email)

      if (roles.length === 1) {
        return roles
      } else {
        return roles.slice(1)
      }
    },

    disableTooltip(email) {
      const { roles } = this.userRoles.find(user => user.email === email)

      return roles.length <= 1
    },
  },
}
</script>
